import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

const PriceSpan = ({ className, cents, amount }) => (
  <span className={className}>
    <FormattedNumber
      value={amount != null ? amount : cents / 100.0}
      style="currency"
      currency={gon.currency}
      minimumFractionDigits={2}
    />
  </span>
);

PriceSpan.propTypes = {
  amount: (props, propName, componentName) => {
    if (props.cents == null && props.amount == null) {
      return new Error(
        `One of props 'cents' or 'amount' was not specified in '${componentName}'.`
      );
    }
  },
  cents: PropTypes.number,
  className: PropTypes.string,
};

export default PriceSpan;



// WEBPACK FOOTER //
// ./app/javascript/common/components/formatters/PriceSpan.js